// Fila de chips removibles para los filtros activos, arriba del listado — se muestran solo
// los que están puestos, cada uno se puede sacar individualmente sin volver a abrir la hoja
// de filtros. `chips`: [{ key, label, onQuitar }].
export default function ChipsFiltros({ chips }) {
    if (!chips || chips.length === 0) return null;

    return (
        <div className="mob-chips-filtros">
            {chips.map((chip) => (
                <button key={chip.key} type="button" className="mob-chip-filtro" onClick={chip.onQuitar}>
                    {chip.label}
                    <i className="bi bi-x" aria-hidden="true" />
                </button>
            ))}
        </div>
    );
}
